import { FC, ReactNode, HTMLAttributes } from 'react'
import { mtc } from '../../../utils/style-helpers'

export interface ListProps {
  items?: string[]
  className?: string
  children?: ReactNode
  bulleted?: boolean
}

interface ListItemProps extends HTMLAttributes<HTMLLIElement> {
  children: ReactNode
  className?: string
  customIcon?: ReactNode
}

export const List: FC<ListProps> & {
  Item: FC<ListItemProps>
} = ({ items, className, children, bulleted = false }) => {
  const listClass = bulleted ? 'list-disc' : ''

  if (!items && !children) {
    return null
  }

  return (
    <ul
      className={mtc(`pl-2 text-neutral-600 text-sm ${listClass}`, className)}
    >
      {items
        ? items.map((item, index) => (
            <li key={index} className="mb-2">
              {item}
            </li>
          ))
        : children}
    </ul>
  )
}

List.Item = ({ children, className, customIcon, ...rest }: ListItemProps) => (
  <li
    className={mtc('mb-2', customIcon && 'flex justify-start gap-1', className)}
    {...rest}
  >
    {customIcon}
    {children}
  </li>
)

List.displayName = 'List'
